namespace TabAurous.OMS {
    export namespace AddressMasterService {
        export const baseUrl = 'OMS/AddressMaster';

        export declare function Create(request: Serenity.SaveRequest<AddressMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AddressMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AddressMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AddressMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetAddress(request: PartyRequest, onSuccess?: (response: Serenity.RetrieveResponse<AddressMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/AddressMaster/Create",
            Update = "OMS/AddressMaster/Update",
            Delete = "OMS/AddressMaster/Delete",
            Retrieve = "OMS/AddressMaster/Retrieve",
            List = "OMS/AddressMaster/List",
            GetAddress = "OMS/AddressMaster/GetAddress"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetAddress'
        ].forEach(x => {
            (<any>AddressMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
